import { ReactElement } from "react";
import "./Tab.scss";

interface ITabProps {
  title: string;
  icon?: string;
  children: ReactElement | ReactElement[];
}

const Tab = (props: ITabProps) => {

  return (
    <div className="tab">
      {props.children}
    </div>
  )
}

export default Tab;